module.exports = __webpack_public_path__ + "static/03-b4bc883f0039f1bd8216d3ea2640379b.jpg";